import "react-toastify/dist/ReactToastify.css";
import "./App.css"

import { Route, Routes } from "react-router-dom";

import AddCv from "./components/AddCv";
import { AuthProvider } from "providers/AuthProvider";
import BreadCrumb from "./components/BreadCrumb";
import CandidateForm from "./pages/CandidateForm";
import { CssBaseline } from "@mui/material";
import CvDetails from "./pages/CvDetails";
import DashBoard from "./pages/CandidateDashboard/DashBoard";
import FilesAndMedia from "./pages/CandidateDashboard/FileManager";
import Header from "./components/Header";
import HomeDashboard from "pages/CandidateDashboard/HomeDashboard";
import NotFound from "./pages/NotFound";
import { ProfileProvider } from "providers/ProfileProvider";
import { ThemeProvider } from '@mui/material/styles';
import UserInfo from "./pages/UserInfo";
import theme from './theme';

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <ThemeProvider theme={theme}>
            <Header />
            <BreadCrumb />
            <div className="App">
              <Routes>
                <Route path="/" element={<HomeDashboard />} />
                 <Route path="/cvs" element={<DashBoard />} />
                <Route path="/cvdetails/:id" element={<CvDetails />} />
                <Route path="/uploaded-files" element={<FilesAndMedia />} />
                <Route path="/userinfo/:id" element={<UserInfo />} />
                <Route path="/AddCv" element={<AddCv />} />
                <Route path="/onboarding" element={<CandidateForm />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <CssBaseline />
            </div>
        </ThemeProvider>
        </ProfileProvider>
    </AuthProvider>
  );
}

export default App;